// components/site-headerMenus.ts

export function shouldResetHeaderMenus(
  previousPathname: string,
  nextPathname: string,
): boolean {
  return previousPathname !== nextPathname;
}
